<template>
  <pt-download-the-form class="pt-download-the-form__page"></pt-download-the-form>
</template>

<script>
import PtDownloadTheForm from 'cps//pt-download-the-form/withData'
export default {
  name: 'pt-download-the-form__view',
  components: {
    'pt-download-the-form': PtDownloadTheForm
  }
}
</script>
